import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  totalCount: 0,
  items: [],
  loading: false,
  error: null
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    setWishlistCount: (state, action) => {
      state.totalCount = action.payload;
    },
    setWishlistItems: (state, action) => {
      state.items = action.payload;
      state.totalCount = action.payload.length;
    },
    setWishlist: (state, action) => {
      state.items = action.payload;
      state.totalCount = action.payload.length;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    incrementWishlistCount: (state) => {
      state.totalCount += 0;
    },
    decrementWishlistCount: (state) => {
      state.totalCount = Math.max(0, state.totalCount - 1);
    },
    addToWishlist(state, action) {
      const existingItem = state.items.find(item => item._id === action.payload._id);
      if (!existingItem) {
        state.items.push(action.payload);
        state.totalCount += 1;
      }
    },
    removeFromWishlist(state, action) {
      state.items = state.items.filter(item => item._id !== action.payload);
      state.totalCount = Math.max(0, state.totalCount - 1);
    },
    clearWishlist(state) {
      state.items = [];
      state.totalCount = 0;
    }
  }
});

export const {
  setWishlistCount,
  setWishlistItems,
  setWishlist,
  setLoading,
  setError,
  incrementWishlistCount,
  decrementWishlistCount,
  addToWishlist,
  removeFromWishlist,
  clearWishlist
} = wishlistSlice.actions;

export default wishlistSlice.reducer;

// In your wishlistSlice.js, after every add/remove:
// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   items: JSON.parse(localStorage.getItem('wishlistItems')) || []
// };

// const wishlistSlice = createSlice({
//   name: 'wishlist',
//   initialState,
//   reducers: {
//     addToWishlist: (state, action) => {
//       state.items.push(action.payload);
//       localStorage.setItem('wishlistItems', JSON.stringify(state.items));
//     },
//     removeFromWishlist: (state, action) => {
//       state.items = state.items.filter(item => item._id !== action.payload._id);
//       localStorage.setItem('wishlistItems', JSON.stringify(state.items));
//     },
//     // Optionally, a way to set the whole wishlist (for rehydration)
//     setWishlist: (state, action) => {
//       state.items = action.payload;
//       localStorage.setItem('wishlistItems', JSON.stringify(state.items));
//     }
//   }
// });

// export const { addToWishlist, removeFromWishlist, setWishlist } = wishlistSlice.actions;
// export default wishlistSlice.reducer;
